<template>
  <div class="p-pnt">
    <div class="l-container">
      <div class="c-box mb-16 mt-px">
        <PlanDetailHeader v-model="planDetail" />
        <MenuNavigation />

        <div class="menu-main-content">
          <section>
            <div class="main-top">
              <div class="main-top-left">
                <a
                  class="inline-flex items-center"
                  href="javascript:void(0)"
                  @click="$router.push('/bs-men-02-010')"
                >
                  <i class="icon icon-bor-arrow-left pr-2" style="font-size: 10px" />
                  <span class="text-black">プラン一覧に戻る</span>
                </a>
              </div>
              <div class="main-top-right lg:hidden">
                <button
                  class="c-btn btn-white btn-sm"
                  href="#intro"
                  v-smooth-scroll="{ offset: -5 }"
                >
                  <i class="icon icon-bor-circle-question pr-2" />
                  <span>ご利用方法</span>
                </button>
              </div>
            </div>
          </section>

          <!-- /* Carousel */ -->
          <section class="lg:pl-4">
            <div class="pnl-title flex items-start">
              <div class="label label-primary mt-2 mr-4" v-if="checkFiveDay()">NEW</div>
              <h3 class="two-lines-ellipsis" v-if="planBasicInfo">
                {{ planBasicInfo.planNm }}
              </h3>
            </div>
            <div class="main-demo">
              <div class="menu-carousel">
                <CarouselThumbnail
                  class="mb-4 lg:hidden"
                  :slides="planBasicInfo.planImages"
                  :slidesToShow="planBasicInfo.planImages.length"
                  v-if="planBasicInfo && Array.isArray(planBasicInfo.planImages)"
                />
                <div
                  class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                  v-if="planBasicInfo && Array.isArray(planBasicInfo.planImages)"
                >
                  <img
                    :src="img.imageUrl"
                    :alt="img.imageExplanation"
                    v-for="(img, idx) in planBasicInfo.planImages"
                    :key="`plan-img-${idx}`"
                  />
                </div>
                <a class="leading-none text-black" @click="showPhotoGallery">
                  フォトギャラリーを見る
                  <i
                    class="icon icon-bor-arrow-right text-primary text-sm pl-2 leading-none"
                  />
                </a>
              </div>
              <div class="menu-calendar">
                <div class="menu-price flex">
                  <p class="text-xs font-bold" v-show="baseOnPrice !== 'room'">
                    大人1人／1泊の料金
                  </p>
                  <p class="text-xs font-bold" v-show="baseOnPrice === 'room'">
                    客室料金
                  </p>
                  <div class="price-content">
                    <strong>
                      {{ todayPrice | formatInteger }}
                    </strong>
                    <span>円～</span>
                  </div>
                </div>
                <p class="text-primary font-bold lg:mb-2 mb-4 text-right pt-2">
                  ベネポ２％付与（１名１室利用：6%）
                </p>

                <!-- Box Coupons -->
                <div class="box-coupons">
                  <div class="box-coupons-left text-center">
                    <i class="icon icon-bor-coupons text-primary" />
                    <span class="hidden lg:block">補助クーポン 利用可能</span>
                  </div>
                  <a-divider type="vertical" class="divider" />
                  <div class="coupons-contents">
                    <div class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2">
                      <strong class="py-0.5">補助クーポン利用で</strong>
                      <strong class="coupons-contents_priceText text-primary">
                        1泊1名
                        <span class="price">500</span>
                        円
                      </strong>
                    </div>
                    <p class="text-xs text-desc">
                      <span class="pr-2 lg:pr-0">適用条件〜〜〜〜</span>
                      <span>利用期限〜〜〜〜</span>
                    </p>
                  </div>
                </div>

                <div class="coupons-meta">
                  <div class="room-left">
                    <img
                      src="@/assets/images/recomment-rakuten.png"
                      alt="demo"
                      v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'"
                    />
                    <img
                      src="@/assets/images/bene-log.png"
                      alt="demo"
                      v-if="!menuInformation || menuInformation.extSystemCd != 'RakutenT'"
                    />
                    <div class="services-offer">
                      <div class="item">
                        <i class="icon icon-bor-food" />
                        <span>
                          {{ roomEatServiceDesc }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="flex items-center text-status">
                    <i class="icon icon-bor-status pr-2" />
                    <span class="lg:text-xs">
                      チェックイン
                      <span v-if="planUsage && planUsage.usageDetailStay">
                        {{ planUsage.usageDetailStay.checkInTm | formatTimeOnly }} -
                        {{ planUsage.usageDetailStay.lastCheckInTm | formatTimeOnly }}
                      </span>
                      ／ チェックアウト
                      <span v-if="planUsage && planUsage.usageDetailStay">
                        {{ planUsage.usageDetailStay.checkOutTm | formatTimeOnly }}
                      </span>
                    </span>
                  </div>

                  <div class="divider" />

                  <!-- Hotel Meta -->
                  <div class="hotel-meta-wrap">
                    <div class="hotel-meta">
                      <div class="meta-item">
                        <i class="icon icon-bor-people" />
                        定員
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.maxStayCapacity"
                          >{{ roomBasicInfo.maxStayCapacity | formatInteger }}</span
                        >名
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-bed" />
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.roomCondNm"
                          >{{ roomBasicInfo.roomCondNm }}</span
                        >
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-m2" />
                        部屋のサイズ
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.roomSizeTxt"
                          >{{ roomBasicInfo.roomSizeTxt }}</span
                        >
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-no-smoking" />
                        <span v-if="roomBasicInfo && roomBasicInfo.smokingDiv">{{
                          roomBasicInfo.smokingDiv
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="recommended-right">
                    <Tag
                      size="small"
                      class="mr-1"
                      v-for="(flag, index) in getUsageDetails"
                      :key="`usage-flag-${index}`"
                    >
                      {{ flag.label }}
                    </Tag>
                  </div>
                </div>

                <a href="#planSelection" v-smooth-scroll="{ offset: -120 }">
                  <button class="c-btn btn-reserve w-full">予約する</button>
                </a>

                <div class="menu-calendar_expire">
                  <p class="mr-4">
                    予約受付期間：
                    <span
                      v-if="
                        planUsage &&
                        planUsage.usageDetailStay &&
                        planUsage.usageDetailStay.rsvReceptSttDtTxt
                      "
                    >
                      {{
                        planUsage.usageDetailStay.rsvReceptSttDtTxt
                          | formatDate('YYYY/MM/DD', 'YYYYMMDD')
                      }}
                    </span>
                    <span v-else>随時受付</span>
                  </p>
                  <p>
                    予約受付締切日：
                    <span
                      v-if="
                        planUsage &&
                        planUsage.usageDetailStay &&
                        planUsage.usageDetailStay.rsvReceptEndDtTxt
                      "
                    >
                      {{
                        planUsage.usageDetailStay.rsvReceptEndDtTxt
                          | formatDate('YYYY/MM/DD', 'YYYYMMDD')
                      }}
                    </span>
                    <span v-else>随時受付</span>
                  </p>
                </div>

                <label class="menu-calendar_payment">
                  お支払い方法：<br />
                  <span> 銀行振り込み／クレジットカード／カフェポイント利用 </span>
                </label>
                <!-- <div class="flex text-xs mb-6 flex-wrap">
                  <span class="whitespace-nowrap">お支払い方法：</span>
                  <span class="mx-2">／</span>
                  <span class="whitespace-nowrap">
                    クレジットカード
                    <i class="icon icon-bor-circle-question pl-2" />
                  </span>
                  <span class="mx-2">／</span>
                  <span class="whitespace-nowrap">お支払い方法：</span>
                </div> -->

                <div
                  class="box-notify mb-4 mt-4"
                  v-if="usageLimitInformation && usageLimitInformation[0].usageLimitCont"
                >
                  <span>
                    {{ usageLimitInformation[0].usageLimitCont }}
                  </span>
                </div>

                <p class="menu-calendar_id" v-if="planBasicInfo && planBasicInfo.planId">
                  プランID:{{ planBasicInfo.planId }}
                </p>
                <!-- CRM汎用対応 -->
                <!-- <div class="coupons-social">
                  <Share label="プランをシェアする" :favorite="false" size="large" />
                </div> -->
              </div>
            </div>
            <div class="divider mb-4 mt-8" />
          </section>

          <!-- ViewMore -->
          <section v-if="planInfomation && Array.isArray(planInfomation)">
            <div class="title-box v-line">
              <h2>インフォメーション</h2>
            </div>

            <div
              class="main-description"
              v-for="(info, index) in planInfomation"
              :key="`info-${index}`"
            >
              <BoxViewMore>
                <h3>
                  {{ info.title }}
                </h3>
                <p class="mb-3">
                  {{ info.content }}
                </p>
                <p>
                  <a
                    :href="info.linkUrl"
                    target="_blank"
                    class="blue"
                    v-if="info && info.linkUrl && info.linkNm"
                    >{{ info.linkNm }}</a
                  >
                </p>
              </BoxViewMore>
            </div>
            <div class="divider mb-4 mt-8" />
          </section>

          <!-- Box Text availability -->
          <section>
            <div class="main-availability">
              <SectionContentTitle lineType="v-line" titleContent="空室状況" />
              <p class="mb-6 sm:hidden">カレンダーから宿泊日を指定してください。</p>
              <div class="form-book">
                <div class="calendar-wrap">
                  <div class="cm-calendar">
                    <Calendar
                      v-model="stayDay"
                      @input="stayDay = $event"
                      :selectedDays="getSelectedDays"
                      :dayOpens="filterOpenDays"
                      :dayOpenDecorator="dayOpenDecorator"
                      :dayFewLefts="filterFewLeftDays"
                      :fewLeftDecorator="fewLeftDecorator"
                      :dayCloses="filterCloseDays"
                      :dayClosedDecorator="dayClosedDecorator"
                      :disabledDate="checkDisabledDate"
                      :disabledPrev="calendarDisabledPrev"
                    />
                  </div>
                  <p class="text-left lg:text-right text-xs pt-4">
                    ※１室あたりの料金です
                  </p>
                </div>
                <div class="form-wrap" id="planSelection">
                  <div class="form-frame p-4">
                    <p class="form-title">予約内容</p>
                    <div class="field flex-nowrap">
                      <a-date-picker
                        v-model="stayDay"
                        type="date"
                        format="YYYY/MM/DD"
                        :disabledDate="checkDisabledDate"
                        :allowClear="false"
                      >
                      </a-date-picker>
                      <span class="px-2 whitespace-nowrap">から</span>
                      <a-select v-model="stayNights" class="w-16">
                        <a-select-option
                          :value="el.value"
                          v-for="(el, index) in nightOptions"
                          :key="`room-${index}`"
                          :disabled="
                            maxSelectableNight !== null && el.value > maxSelectableNight
                          "
                        >
                          {{ el.label }}
                        </a-select-option>
                      </a-select>
                      <span class="pl-2">泊</span>
                    </div>

                    <div class="field">
                      <a-select v-model="stayRooms" class="w-24">
                        <a-select-option
                          :value="el.value"
                          v-for="(el, index) in roomOptions"
                          :key="`room-${index}`"
                          :disabled="
                            maxSelectableRoom !== null && el.value > maxSelectableRoom
                          "
                        >
                          {{ el.label }}
                        </a-select-option>
                      </a-select>
                      <span class="pl-2">部屋</span>
                    </div>

                    <div class="field mb-8 lg:mb-6">
                      <span class="pr-2">大人</span>
                      <a-select v-model="stayAdults" class="w-20">
                        <a-select-option
                          :value="el.value"
                          v-for="(el, index) in peopleOptions"
                          :key="`people-${index}`"
                          :disabled="
                            maxSelectablePeople !== null && el.value > maxSelectablePeople
                          "
                        >
                          {{ el.label }}
                        </a-select-option>
                      </a-select>
                      <span class="pl-2 pr-4">人</span>

                      <a-popover
                        v-model="showAttachChildren"
                        placement="bottom"
                        trigger="click"
                        class="children-attach"
                      >
                        <button class="font-bold">
                          子どもを追加する<span v-if="countTotalChildren">
                            ({{ countTotalChildren }})</span
                          >
                          <i class="icon icon-bor-circle-plus pl-2" />
                        </button>
                        <div slot="content" class="children-attach-content">
                          <div class="popover-block-first">
                            <div class="block-first-title">小学生</div>
                            <div class="block-first-content">
                              <div class="set-value-group">
                                <div class="set-value-name">高学年</div>
                                <Stepper
                                  v-model="attachChildren.childrenType10"
                                  size="large"
                                  unit="人"
                                  @keyup="inputChildren('childrenType10', $event)"
                                  max="99"
                                />
                              </div>
                              <div class="set-value-group">
                                <div class="set-value-name">低学年</div>
                                <Stepper
                                  v-model="attachChildren.childrenType15"
                                  size="large"
                                  unit="人"
                                  @keyup="inputChildren('childrenType15', $event)"
                                  max="99"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="popover-block-second">
                            <div class="block-second-title">幼児</div>
                            <div class="block-second-content">
                              <div class="set-value-group">
                                <div class="set-value-name">食事・布団付</div>
                                <Stepper
                                  v-model="attachChildren.childrenType20"
                                  size="large"
                                  unit="人"
                                  @keyup="inputChildren('childrenType20', $event)"
                                  max="99"
                                />
                              </div>
                              <div class="set-value-group">
                                <div class="set-value-name">食事のみ</div>
                                <Stepper
                                  v-model="attachChildren.childrenType30"
                                  size="large"
                                  unit="人"
                                  max="99"
                                  @keyup="inputChildren('childrenType30', $event)"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="popover-block-three">
                            <div class="block-three-content">
                              <div class="set-value-group">
                                <div class="set-value-name">布団のみ</div>
                                <Stepper
                                  v-model="attachChildren.childrenType40"
                                  size="large"
                                  unit="人"
                                  @keyup="inputChildren('childrenType40', $event)"
                                  max="99"
                                />
                              </div>
                              <div class="set-value-group">
                                <div class="set-value-name">食事・布団不要</div>
                                <Stepper
                                  v-model="attachChildren.childrenType50"
                                  size="large"
                                  unit="人"
                                  max="99"
                                  @keyup="inputChildren('childrenType50', $event)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </a-popover>
                    </div>

                    <div class="plan-price">
                      <div class="plan-price-left">
                        <div>
                          <label>合計料金</label>
                          <span>税込</span>
                        </div>
                        <span class="price">
                          {{ calculateMemberAmount | formatCurrency }}
                        </span>
                      </div>
                      <div class="plan-price-right">
                        <label>ビジター価格 税込</label>
                        <span class="price">{{
                          computeVisitorStayAmount | formatCurrency
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="granted-benepo-stay w-full mb-6"
                      v-if="calculateMemberAmount"
                    >
                      獲得予定ベネポ：{{ grantedBenepo | formatInteger }}P
                    </div>
                    <Button
                      class="c-btn w-full btn-reserve"
                      size="large"
                      :loading="loading"
                      @click="goNext"
                      >予約する</Button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Divider -->
            <div class="divider mb-4 mt-8"></div>
          </section>

          <!-- Room Detail -->
          <section>
            <div class="room-detail">
              <SectionContentTitle lineType="v-line" titleContent="お部屋の詳細" />
              <div class="room-detail-wrap">
                <div class="room-detail-left">
                  <div class="recommended-right hidden">
                    <div class="label label-grey-200">現地決済予約</div>
                    <div class="label label-grey-200">事前決済予約</div>
                    <div class="label label-grey-200">カフェポイント</div>
                    <div class="label label-grey-200">すくすくえいど</div>
                    <div class="label label-grey-200">介護補助</div>
                  </div>

                  <div class="room-detail-title">
                    <h3 v-if="roomBasicInfo && roomBasicInfo.roomNm">
                      {{ roomBasicInfo.roomNm }}
                    </h3>
                  </div>

                  <div class="hotel-meta-wrap">
                    <div class="hotel-meta">
                      <!-- <div class="meta-item" v-for="(info, index) in getRoomBasicInfoList" :key="`room-basic-info-${index}`">
                        <i class="icon icon-bor-people" />
                        {{info.label}} <span v-if="roomBasicInfo && roomBasicInfo.maxStayCapacity">{{info.value}}</span>名
                      </div> -->
                      <div class="meta-item">
                        <i class="icon icon-bor-people" />
                        定員
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.maxStayCapacity"
                          >{{ roomBasicInfo.maxStayCapacity | formatInteger }}</span
                        >名
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-bed" />
                        キングベッド
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.roomCondNm"
                          >{{ roomBasicInfo.roomCondNm | formatInteger }}台</span
                        >
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-m2" />
                        部屋のサイズ
                        <span
                          class="mx-1"
                          v-if="roomBasicInfo && roomBasicInfo.roomSizeTxt"
                          >{{ roomBasicInfo.roomSizeTxt }}</span
                        >
                      </div>
                      <div class="meta-item">
                        <i class="icon icon-bor-no-smoking" />
                        <span v-if="roomBasicInfo && roomBasicInfo.smokingDiv">{{
                          roomBasicInfo.smokingDiv
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                    :style="{ 'background-image': `url(${roomImagePreview})` }"
                    @click="
                      previewPlanImage(
                        roomBasicInfo.roomImages && roomBasicInfo.roomImages.length
                          ? roomBasicInfo.roomImages
                          : null
                      )
                    "
                  ></div>

                  <div
                    class="room-detail-content whitespace-pre-wrap"
                    v-if="roomBasicInfo && roomBasicInfo.note"
                    v-html="roomBasicInfo.note"
                  />
                </div>
                <div class="room-detail-right sm:hidden">
                  <div class="room-detail-right_inner">
                    <div
                      class="room-detail-right_inner-image sm:hidden"
                      :style="{ 'background-image': `url(${roomImagePreview})` }"
                      @click="
                        previewPlanImage(
                          roomBasicInfo.roomImages && roomBasicInfo.roomImages.length
                            ? roomBasicInfo.roomImages
                            : null
                        )
                      "
                    ></div>
                    <div class="room-detail-right_inner-title">
                      <span class="one-lines-ellipsis">
                        {{ roomExplanImagePreview }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="divider mb-4 mt-8" />
          </section>

          <!-- Plan Detail -->
          <section>
            <div class="plan-detail room-detail">
              <SectionContentTitle lineType="v-line" titleContent="プランの詳細" />
              <div class="room-detail-wrap">
                <div class="room-detail-left">
                  <div class="room-detail-title">
                    <h3 class="lg:text-lg" v-if="planBasicInfo && planBasicInfo.planNm">
                      {{ planBasicInfo.planNm }}
                    </h3>
                  </div>

                  <div class="room-detail-content">
                    <div
                      class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                      v-if="planBasicInfo && planBasicInfo.planImages"
                    >
                      <img
                        :src="planImg.imageUrl"
                        :alt="planImg.imageExplanation"
                        v-for="(planImg, index) in planBasicInfo.planImages"
                        :key="`plan-slide-${index}`"
                      />
                    </div>
                    <!-- <div class="slide-images-mobile hidden lg:flex object-contain" v-if="planBasicInfo && Array.isArray(planBasicInfo.planImages)">
                      <img :src="planBasicInfo.planImages[0].imageUrl" :alt="planBasicInfo.planImages[0].imageExplanation"/>
                    </div> -->
                    <div
                      class="whitespace-pre-wrap mb-4"
                      v-if="planBasicInfo && planBasicInfo.planLeadCopy"
                      v-html="planBasicInfo.planLeadCopy"
                    />
                  </div>
                </div>

                <div class="room-detail-right lg:hidden">
                  <CarouselThumbnail
                    :slides="planBasicInfo.slides"
                    slidesToShow="3"
                    showLabel
                    isSmall
                    v-if="planBasicInfo && Array.isArray(planBasicInfo.slides)"
                  />
                </div>
              </div>
              <div class="room-detail-footer mt-10 lg:hidden" id="intro">
                <span class="flex items-center">
                  <i class="icon icon-bor-circle-question pr-2" />
                  ご利用方法
                </span>
                <div class="flex gap-x-4">
                  <div v-for="(icon, index) in getPlanIcons" :key="`plan-icon-${index}`">
                    <a @click="handleOpenIntro" class="mr-4">{{ icon.iconNm }}</a>
                    <a-divider type="vertical" v-if="index < getPlanIcons.length - 1" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Divider -->
            <div class="divider my-8"></div>
          </section>

          <!-- Cancel Policy -->
          <section v-if="cancelPolicy && cancelPolicy.cancelPolicies">
            <div
              class="cancel-policy"
              v-for="(ele, index) in cancelPolicy.cancelPolicies"
              :key="`cancel-policy-${index}`"
            >
              <SectionContentTitle
                class=""
                lineType="v-line"
                :titleContent="ele.cancelTitle"
              />
              <p
                class="whitespace-pre-wrap"
                v-html="ele.cancelNote1"
                v-if="ele.cancelNote1"
              ></p>
              <p
                class="whitespace-pre-wrap text-grey-600 mb-6 mt-2"
                style="font-size: 14px"
                v-html="ele.cancelNote2"
                v-if="ele.cancelNote2"
              ></p>
              <a-table
                class="sm:hidden block"
                :columns="cancelPolicyColumns"
                :data-source="ele.cancelPolicyTable"
                :rowKey="
                  (item, index) => {
                    return index
                  }
                "
                v-if="ele.cancelPolicyTable"
                bordered
              >
              </a-table>
            </div>
            <!-- Divider -->
          </section>

          <!-- Guideline-child -->
          <section>
            <div class="guideline-child">
              <SectionContentTitle
                lineType="v-line"
                titleContent="子ども料金の目安について"
              />
              <a-table
                class="sm:hidden block"
                :columns="childGuidelineColumns"
                :data-source="childPriceInfo.childInfos"
                :rowKey="
                  (item, index) => {
                    return `guideline-${index}`
                  }
                "
                bordered
              >
              </a-table>

              <div class="policy-information sm:block hidden">
                <div class="main-detail-information">
                  <div
                    v-for="(i, idx) in 4"
                    :key="`guilde-children-${idx}`"
                    class="item-detail-label w-full"
                  >
                    <div class="label label-lg label-grey-200">小学生</div>
                    <div class="item-detail-content">
                      <div class="item-line">
                        <label>内容：</label>
                        <p>内容が入ります内容が入ります内容が入ります内容が入ります%</p>
                      </div>
                      <div class="item-line">
                        <label>料金の目安：</label>
                        <p>大人料金に対して100%%</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-end pt-4">
                <a href="#">
                  <span class="text-black" @click="openChildrenPolicy()"
                    >お子様連れの方へ</span
                  >
                  <i class="icon icon-bor-arrow-right text-xs pl-2" />
                </a>
              </div>
            </div>
            <!-- Divider -->
          </section>

          <!-- accommodation tax -->
          <section>
            <div class="accommodation-tax cancel-policy">
              <SectionContentTitle lineType="v-line" titleContent="宿泊税について" />
              <p
                class="whitespace-pre-wrap mb-3"
                v-if="vacancyCalendar && vacancyCalendar.stayTaxInfo"
                v-html="vacancyCalendar.stayTaxInfo"
              ></p>
              <div class="flex justify-end">
                <a @click="openTaxLink" target="_blank">
                  <span class="text-black">詳細はこちら</span>
                  <i class="icon icon-bor-arrow-right text-xs pl-2" />
                </a>
              </div>
            </div>
          </section>

          <section class="pb-8" v-if="vacancyCalendar && vacancyCalendar.priceRemarks">
            <div class="accommodation-tax cancel-policy">
              <SectionContentTitle lineType="v-line" titleContent="料金特記事項" />
              <p
                class="whitespace-pre-wrap mb-3"
                v-if="vacancyCalendar && vacancyCalendar.priceRemarks"
                v-html="vacancyCalendar.priceRemarks"
              ></p>
            </div>
            <!-- Divider -->
            <div class="divider mb-4 mt-8"></div>
          </section>

          <div class="footer-detail pb-20">
            <a href="#planSelection" v-smooth-scroll="{ offset: -120 }"
              ><button class="c-btn btn-black">日付を選択して予約する</button></a
            >
          </div>
        </div>
      </div>
    </div>

    <GalleryViewPopup
      :visible="showGallery"
      v-model="galleryData"
      @ok="showGallery = false"
      @close="showGallery = false"
    />

    <!-- Image Preview -->
    <Modal
      :visible="showPreviewImg"
      size="large"
      @cancel="showPreviewImg = false"
      @ok="showPreviewImg = false"
    >
      <div class="w-full" v-if="previewImage">
        <img :src="previewImage[0].imageUrl" class="image-preview" />
      </div>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-unused-components */
import moment from 'moment'
import _ from 'lodash'
import plan_utils from '@/mixins/plan_utils'
import {
  MenuNavigation,
  CarouselThumbnail,
  BoxViewMore,
  SectionContentTitle
} from '@/components/compound'
import { Button, Tag, Calendar, Stepper, Modal } from '@/components/primitive'
import PlanDetailHeader from '../PlanDetailHeader'
import GalleryViewPopup from '../../menu/GalleryViewPopup'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import { BASE_ON_PRICE, SAVE_CUSTOMER_PLAN } from '@/store/modules/plan/actions'
import { SAVE_DATA_BS_APP_02_001 } from '@/store/modules/bs_app/actions'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'
import { ROOM_INFO_PUBLIC_ATTRS, ROOM_INFO_LABEL } from '@/constants/room'

const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')

const CHANGE_CONTROL = {
  ROOM: 'room',
  ADULT: 'adult'
}

export default {
  mixins: [plan_utils],
  components: {
    Button,
    BoxViewMore,
    Calendar,
    CarouselThumbnail,
    MenuNavigation,
    Tag,
    Stepper,
    PlanDetailHeader,
    SectionContentTitle,
    GalleryViewPopup,
    Modal
  },
  data() {
    return {
      breadcrumbs: [],
      loading: false,
      showPreviewImg: false,
      previewImage: [
        {
          imageUrl: '',
          imageExplanation: ''
        }
      ],
      dateFormat: 'YYYY/MM/DD',
      instockDayMap: {},
      fewLeftDayMap: {},
      outstockDayMap: {},
      planDetail: null,
      cancelPolicy: null,
      menuInformation: null,
      planBasicInfo: null,
      planInfomation: null,
      planUsage: null,
      planUsageLimit: null,
      usageLimitInformation: null,
      roomBasicInfo: null,
      currentMonthCalendar: null,
      vacancyCalendar: null,
      stayDay: moment(new Date()),
      stayNights: 1,
      stayRooms: 1,
      stayAdults: 1,
      changeControl: {
        init: true,
        key: null
      },
      planRcSttDt: null,
      maxStayCapacity: null,
      minStayCapacity: 1,
      attachChildren: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      showGallery: false,
      galleryData: [],
      showAttachChildren: false,
      selectedDaysInfo: [],
      limitNights: 10,
      limitRooms: 10,
      limitPeoples: 10,
      maxSelectablePeople: null,
      maxSelectableRoom: null,
      maxSelectableNight: null,
      baseImg: require('@/assets/images/base.png'),
      cancelPolicyColumns: [
        {
          title: 'キャンセル日',
          dataIndex: 'cancelRule',
          width: 263
        },
        {
          title: '規定率',
          dataIndex: 'cancelCond'
        }
      ],
      childGuidelineColumns: [
        {
          title: '区分',
          dataIndex: 'childDiv',
          scopedSlots: { customRender: 'childDiv' },
          width: 263
        },
        {
          title: '内容',
          dataIndex: 'content',
          width: 420
        },
        {
          title: '料金の目安',
          dataIndex: 'priceReference'
        }
      ],
      childPriceInfo: {
        childInfos: []
      },
      // errorControl: {
      //   tryCount: 0
      // }
      grantedBenepo: 0
    }
  },
  created() {
    this.changeControl.init = true
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
    // CLEAR FLOW DATA
    this.$store.dispatch(SAVE_DATA_BS_APP_02_001, null)
  },
  mounted() {
    const { menuNo, planId, roomId, companyCd } = this.$route.query
    this.$repositories('plan')
      .getPlanDetail(menuNo, planId, roomId)
      .then((data) => {
        // update breadcrumbs
        this.breadcrumbs[this.breadcrumbs.length - 1].title = _.get(
          data,
          'planBasicInfo.planNm',
          ''
        )
        this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
        this.planDetail = data
        this.cancelPolicy = _.get(this.planDetail, 'cancelPolicy', null)
        if (this.cancelPolicy && Array.isArray(this.cancelPolicy.cancelPolicies)) {
          this.cancelPolicy.cancelPolicies = this.cancelPolicy.cancelPolicies.map(
            (cancel, index) => {
              cancel.id = `cancelPolicy-${index + 1}`
              if (cancel.cancelPolicyTable) {
                cancel.cancelPolicyTable = cancel.cancelPolicyTable.map((el, idx) => {
                  if (!el.id) {
                    el.id = `cancelPolicyTable-${idx + 1}`
                  }
                  return el
                })
              }
              return cancel
            }
          )
        }
        this.menuInformation = this.planDetail.menuInformation
        this.planBasicInfo = this.planDetail.planBasicInfo
        if (this.planBasicInfo) {
          if (
            !Array.isArray(this.planBasicInfo.planImages) ||
            !this.planBasicInfo.planImages.length
          ) {
            this.planBasicInfo.planImages = [
              {
                imageUrl: PLACEHOLDER_IMG,
                imageExplanation: ''
              }
            ]
          }
          this.planBasicInfo.slides = this.planBasicInfo.planImages.map((item) => {
            return {
              imageUrl: item.imageUrl,
              label: item.imageExplanation
            }
          })
        }
        this.planRcSttDt = this.planDetail.planBasicInfo.planRcSttDt
        this.planInfomation = this.planDetail.planInfomation
        this.planUsage = this.planDetail.planUsage
        this.usageLimitInformation = this.planDetail.usageLimitInformation
        this.roomBasicInfo = this.planDetail.roomBasicInfo
        this.vacancyCalendar = this.planDetail.vacancyCalendar
        this.childPriceInfo['childInfos'] = _.get(
          this.vacancyCalendar,
          'childPriceInfo.childInfos',
          []
        )

        this.maxStayCapacity =
          this.roomBasicInfo && this.roomBasicInfo.maxStayCapacity
            ? this.roomBasicInfo.maxStayCapacity
            : null
        this.minStayCapacity =
          this.roomBasicInfo && this.roomBasicInfo.minStayCapacity !== null
            ? this.roomBasicInfo.minStayCapacity
            : null

        const customerPlan = this.getCustomerPlan
        if (customerPlan) {
          this.stayDay = moment(customerPlan.stayDay, 'YYYY年MM月DD日から')
          this.stayNights = customerPlan.stayNights
          this.stayRooms = customerPlan.stayRooms
          this.stayAdults = customerPlan.stayAdults
          this.attachChildren = customerPlan.attachChildren
        }

        this.setLimitRoomCapacity()
        this.getVacancyCalendar()
        this.calculateStayAmount()
        this.setMaxSelectable()

        this.$nextTick(() => {
          this.changeControl.init = false
        })
      })
  },
  watch: {
    calculateMemberAmount(val) {
      const { menuNo, planId } = this.$route.query
      if (menuNo && planId) this.getGrantedBenepoStay(menuNo, planId, val)
    },
    stayDay(val, old) {
      // GET ROOM PRICE FOR SELECTED MONTH
      if (val && !val.isSame(old, 'month')) {
        this.$nextTick(() => {
          this.getVacancyCalendar()
        })
      }

      this.calculateStayAmount()
      this.setMaxSelectable()
    },
    stayNights() {
      this.calculateStayAmount()
      this.setMaxSelectable()
    },
    stayRooms() {
      if (this.changeControl.key === null) {
        this.changeControl.key = CHANGE_CONTROL.ROOM
        this.setPeopleBaseOnRoom()
        this.calculateStayAmount()
        this.setMaxSelectable()
        this.getVacancyCalendar()
        this.$nextTick(() => {
          this.changeControl.key = null
        })
      }
    },
    stayAdults() {
      if (this.changeControl.key === null) {
        this.changeControl.key = CHANGE_CONTROL.ADULT
        this.setRoomBaseOnPeople()
        this.calculateStayAmount()
        this.setMaxSelectable()
        this.getVacancyCalendar()
        this.$nextTick(() => {
          this.changeControl.key = null
        })
      }
    },
    countTotalChildren() {
      this.getVacancyCalendar()
    },
    attachChildren: {
      deep: true,
      handler(val) {
        // if (this.maxSlotRemaining > 0) {
        //   this.errorControl.tryCount = 0
        // } else {
        //   this.errorControl.tryCount = 1
        // }
      }
    }
  },
  computed: {
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    nightOptions() {
      const nihgts = []
      for (let i = 0; i < this.limitNights; i++) {
        nihgts.push({
          label: i + 1,
          value: i + 1
        })
      }
      return nihgts
    },
    roomOptions() {
      const rooms = []
      for (let i = 0; i < this.limitRooms; i++) {
        rooms.push({
          label: i + 1,
          value: i + 1
        })
      }
      return rooms
    },
    peopleOptions() {
      const peoples = []

      const maxAdultPeople = this.maxStayCapacity * this.limitRooms
      for (let i = 0; i < maxAdultPeople; i++) {
        peoples.push({
          label: i + 1,
          value: i + 1
        })
      }
      return peoples
    },
    getCustomerPlan() {
      return this.$store.getters.customerPlan
    },
    countPeopleSlot() {
      let maxSlot = +this.stayAdults
      Object.keys(this.attachChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          maxSlot += this.attachChildren[key]
        }
      })
      return maxSlot
    },
    maxSlotRemaining() {
      let remainSlots = this.maxStayCapacity * this.stayRooms
      remainSlots -= this.stayAdults
      Object.keys(this.attachChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          remainSlots -= this.attachChildren[key]
        }
      })
      return remainSlots
    },
    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },
    filterOpenDays() {
      this.instockDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 4 || e.stock === 0)
      const instockDays = []
      vacancyCalendars.forEach((el) => {
        this.instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },
    filterFewLeftDays() {
      this.fewLeftDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 0 && e.stock <= 4)
      const fewLeftDays = []
      vacancyCalendars.forEach((el) => {
        this.fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    },
    filterCloseDays() {
      this.outstockDayMap = {}
      const lastDay = this.stayDay.clone().endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          this.stayDay.month() + 1 > 9
            ? this.stayDay.month() + 1
            : `0${this.stayDay.month() + 1}`
        const day = `${this.stayDay.year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },
    todayPrice() {
      if (!this.currentMonthCalendar) {
        return 0
      }
      const today = moment(new Date())
      const vacancyCalendars =
        this.currentMonthCalendar &&
        Array.isArray(this.currentMonthCalendar.vacancyCalendars)
          ? this.currentMonthCalendar.vacancyCalendars
          : []
      const vacancyTodays = vacancyCalendars.filter(
        (v) => v.stayDay === today.format('YYYY/MM/DD')
      )
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        return vacancyTodays.length && vacancyTodays[0].roomPrice
          ? vacancyTodays[0].roomPrice
          : 0
      }
      return vacancyTodays.length && vacancyTodays[0].price ? vacancyTodays[0].price : 0
    },
    roomImagePreview() {
      const roomImage = _.get(this.roomBasicInfo, 'roomImages[0].imageUrl', null)
      if (roomImage) {
        return roomImage
      }
      return PLACEHOLDER_IMG
    },
    roomExplanImagePreview() {
      const imgExplan = _.get(this.roomBasicInfo, 'roomImages[0].imageExplanation', null)
      return imgExplan
    },
    planImagePreview() {
      const planImage = _.get(this.planBasicInfo, 'planImages[0].imageUrl', null)
      if (planImage) {
        return planImage
      }
      return PLACEHOLDER_IMG
    },
    roomEatServiceDesc() {
      const breakfastFlag = +_.get(this.planUsage, 'usageDetailStay.breakfastFlag', 0)
      const dinnerFlag = +_.get(this.planUsage, 'usageDetailStay.dinnerFlag', 0)
      if (breakfastFlag && dinnerFlag) {
        return '朝食・夕食つき'
      } else if (breakfastFlag) {
        return '朝食のみ'
      } else if (dinnerFlag) {
        return 'ディナーのみ'
      }
      return '朝食と夕食は含まれていません'
    },
    getUsageDetails() {
      const usageDetail =
        this.planUsage && this.planUsage.usageDetail ? this.planUsage.usageDetail : {}
      const activeFlags = Object.keys(usageDetail)
        .filter((key) => +usageDetail[key])
        .map((key) => {
          return {
            label: key,
            value: key
          }
        })
      return activeFlags
    },
    getRoomBasicInfoList() {
      const roomBasicInfo = this.roomBasicInfo ? this.roomBasicInfo : {}
      Object.keys(roomBasicInfo)
        .filter(
          (key) =>
            ROOM_INFO_PUBLIC_ATTRS[key] !== undefined &&
            ROOM_INFO_PUBLIC_ATTRS[key] !== null
        )
        .map((key) => {
          return {
            label: ROOM_INFO_LABEL[key],
            value: roomBasicInfo[key],
            attr: key
          }
        })

      return []
    },
    countTotalChildren() {
      return (
        this.attachChildren.childrenType10 +
        this.attachChildren.childrenType15 +
        this.attachChildren.childrenType20 +
        this.attachChildren.childrenType30 +
        this.attachChildren.childrenType40 +
        this.attachChildren.childrenType50
      )
    },
    calculateMemberAmount() {
      const selectedDays = _.cloneDeep(this.getSelectedDays)
      selectedDays.splice(-1)
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      let netAmount = 0
      selectedDays.forEach((day) => {
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
            if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
              netAmount += this.stayRooms * vacancy.price
            } else {
              const memberPrice = vacancy.price ? vacancy.price : 0
              const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
              netAmount += this.stayAdults * memberPrice + this.stayRooms * roomPrice
              if (!roomPrice) {
                Object.keys(this.attachChildren).forEach((key) => {
                  if (this.attachChildren[key]) {
                    netAmount +=
                      this.attachChildren[key] *
                      this.getMemberChildPrice(key, vacancy.childrenPriceTable)
                  }
                })
              }
            }
          }
        })
      })
      return netAmount
    },
    computeVisitorStayAmount() {
      const selectedDays = _.cloneDeep(this.getSelectedDays)
      selectedDays.splice(-1)
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      let netAmount = 0
      selectedDays.forEach((day) => {
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
            if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
              netAmount += this.stayRooms * vacancy.roomPrice
            } else {
              const visitorPrice = vacancy.adultPrice ? vacancy.adultPrice : 0
              const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
              netAmount += this.stayAdults * visitorPrice + this.stayRooms * roomPrice
              if (!roomPrice) {
                Object.keys(this.attachChildren).forEach((key) => {
                  if (this.attachChildren[key]) {
                    netAmount +=
                      this.attachChildren[key] *
                      this.getMemberChildPrice(key, vacancy.childrenPriceTable)
                  }
                })
              }
            }
          }
        })
      })
      return netAmount
    },
    calendarDisabledPrev() {
      const now = moment(new Date())
      return this.stayDay.isSameOrBefore(now, 'month')
    }
  },
  methods: {
    setLimitRoomCapacity() {
      if (_.get(this.menuInformation, 'extSystemCd') === 'RakutenT') {
        this.limitRooms = 10
      } else if (_.get(this.menuInformation, 'extSystemCd') === 'ToyokoInn') {
        this.limitRooms = 4
      } else {
        this.limitRooms = 19
      }
      this.limitPeoples = 19
    },
    setMaxSelectable() {
      // const minRoomStock = this.getMinRoomStock(this.selectedDaysInfo)
      // this.maxSelectableRoom = minRoomStock
      // this.maxSelectablePeople = minRoomStock !== null ? minRoomStock * this.maxStayCapacity : null
      // if (this.stayRooms > this.maxSelectableRoom) {
      //   this.stayRooms = this.maxSelectableRoom
      // } else if (this.stayRooms === 0 && this.maxSelectableRoom > 0) {
      //   this.stayRooms = 1
      // }
      // if (this.maxSelectablePeople === 0) {
      //   this.stayAdults = 0
      // } else {
      //   this.stayAdults = this.stayAdults !== 0 ? this.stayAdults : 1
      // }
    },
    setPeopleBaseOnRoom() {
      // const totalPeopleSlot = this.countPeopleSlot
      // // const maxRooms = this.getMaxAvailableRooms()
      // if (this.stayRooms < totalPeopleSlot / this.maxStayCapacity) {
      //   this.stayAdults = this.maxStayCapacity * this.stayRooms
      // }
      // if (this.stayRooms > this.stayAdults) {
      //   this.stayAdults = this.stayRooms
      // }
      // this.stayAdults = this.stayRooms
      // Object.keys(this.attachChildren).forEach((key) => {
      //   this.attachChildren[key] = 0
      // })
    },
    setRoomBaseOnPeople() {
      // const totalPeopleSlot = this.countPeopleSlot
      // const maxRooms = this.getMaxAvailableRooms()
      // if (maxRooms !== null && totalPeopleSlot > maxRooms * this.maxStayCapacity) {
      //   this.stayAdults = maxRooms * this.maxStayCapacity
      // }
      // if (this.maxStayCapacity !== null && this.stayRooms * this.maxStayCapacity < totalPeopleSlot) {
      //   this.stayRooms = Math.ceil(totalPeopleSlot / this.maxStayCapacity)
      // }
      // if (this.stayRooms > this.stayAdults) {
      //   this.stayRooms = this.stayAdults
      // }
    },
    inputChildren(type, $event) {
      // if ($event.key === 'Backspace') {
      //   this.errorControl.tryCount = 0
      //   return
      // }
      // this.$nextTick(() => {
      //   if (type === 'childrenType30' || type === 'childrenType50') {
      //     if (this.attachChildren[type] >= 99) {
      //       this.$toasted.error(`追加できるのは「${this.getChildTypeName(type)}」の${this.attachChildren[type]}人までです。`)
      //     }
      //     return
      //   }
      //   if (this.maxSlotRemaining <= 0) {
      //     if (this.errorControl.tryCount > 0) {
      //       this.$toasted.error(`追加できるのは「${this.getChildTypeName(type)}」の${this.attachChildren[type]}人までです。`)
      //     }
      //     this.errorControl.tryCount++
      //   } else if (this.errorControl.tryCount !== 0) {
      //     this.errorControl.tryCount = 0
      //   }
      // })
    },
    getVacancyCalendar() {
      const { menuNo, planId, roomId, companyCd } = this.$route.query
      const checkInDay = this.stayDay.clone().startOf('month').format('YYYY/MM/DD')
      const checkOutDay = this.stayDay.clone().endOf('month').format('YYYY/MM/DD')
      const vacancyData = {
        menuNo,
        planId,
        roomId,
        queryParams: {
          companyCd,
          checkInDay,
          checkOutDay,
          roomCnt: this.stayRooms,
          adultHeadCnt: this.stayAdults,
          youjiAHeadCnt: _.get(this.attachChildren, 'childrenType10', 0),
          youjiBHeadCnt: _.get(this.attachChildren, 'childrenType15', 0),
          youjiCHeadCnt: _.get(this.attachChildren, 'childrenType20', 0),
          youjiDHeadCnt: _.get(this.attachChildren, 'childrenType30', 0),
          youjiEHeadCnt: _.get(this.attachChildren, 'childrenType40', 0),
          youjiFHeadCnt: _.get(this.attachChildren, 'childrenType50', 0)
        }
      }
      this.$repositories('plan')
        .getVacancyCalendar(vacancyData)
        .then(
          (result) => {
            this.vacancyCalendar = result
            if (!this.currentMonthCalendar) {
              this.currentMonthCalendar = _.cloneDeep(result)
            }
            this.childPriceInfo['childInfos'] = _.get(
              this.vacancyCalendar,
              'childPriceInfo.childInfos',
              []
            )
            if (
              this.vacancyCalendar &&
              Array.isArray(this.vacancyCalendar.vacancyCalendars) &&
              this.vacancyCalendar.vacancyCalendars.length
            ) {
              if (_.get(this.vacancyCalendar, 'vacancyCalendars[0].roomPrice', null)) {
                // SET BASE ON ROOM PRICE
                this.$store.dispatch(BASE_ON_PRICE, PLAN_BASE_ON_PRICE.ROOM)
              } else {
                // SET BASE ON PEOPLE PRICE
                this.$store.dispatch(BASE_ON_PRICE, PLAN_BASE_ON_PRICE.PEOPLE)
              }
            }
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
    },
    isOutstockDay(date) {
      if (date && this.outstockDayMap[date.format(this.dateFormat)]) {
        return true
      }
      return false
    },
    checkFewLeftDay(date) {
      if (this.fewLeftDayMap[date.format(this.dateFormat)]) {
        return this.fewLeftDayMap[date.format(this.dateFormat)]
      }
      return 0
    },
    getMaxAvailableRooms() {
      let maxAvailableRooms = null
      for (let i = 0; i < this.stayNights; i++) {
        const checkDay = this.stayDay.clone().add(i, 'days')
        if (this.checkFewLeftDay(checkDay)) {
          if (
            maxAvailableRooms === null ||
            maxAvailableRooms > this.fewLeftDayMap[checkDay.format(this.dateFormat)]
          ) {
            maxAvailableRooms = +this.fewLeftDayMap[checkDay.format(this.dateFormat)]
          }
        }
      }
      return maxAvailableRooms
    },
    checkValidStayPeople() {
      const totalSlot = +this.stayAdults
      const maxAvailableRooms = this.getMaxAvailableRooms()
      if (
        maxAvailableRooms !== null &&
        totalSlot / this.maxStayCapacity > maxAvailableRooms
      ) {
        return true
      }
      return false
    },
    checkValidStayRoom() {
      const maxAvailableRooms = this.getMaxAvailableRooms()
      if (maxAvailableRooms !== null && this.stayRooms > maxAvailableRooms) {
        return true
      }
      return false
    },
    validateOK() {
      // CHECK DAY SELECTED IS INSTOCK
      let hasOutStockDay = false
      for (let i = 0; i < this.stayNights; i++) {
        const checkDay = this.stayDay.clone().add(i, 'days')
        if (this.isOutstockDay(checkDay)) {
          hasOutStockDay = true
        }
      }
      if (hasOutStockDay) {
        this.$toasted.error('空室がない日付を選択しました。')
        // this.$toasted.error('空室がない日付を選択しました。')
        return false
      }

      // Số phòng còn lại của khách hàng
      const minStayStock = this.getMinRoomStock(this.selectedDaysInfo)
      if (minStayStock !== null && this.stayRooms > minStayStock) {
        this.$toasted.error('選択された部屋の数が、空室な部屋の数を超えました。')
        // this.$toasted.error('利用可能な部屋の数を超えた人数')
        return false
      }

      // Mỗi phòng cần ít nhất 1 người dùng chăn: minStayCapacity
      if (this.stayRooms > this.countPeopleSlot) {
        this.$toasted.error('選択された人数は、1部屋あたり最低1人に達していません。')
        return false
      }

      // Vượt quá số người 1 phòng: maxStayCapacity
      if (this.countPeopleSlot > this.stayRooms * this.maxStayCapacity) {
        this.$toasted.error('選択された人数が最大数を超えました。')
        return false
      }

      // if (this.checkValidStayPeople()) {
      //   this.$toasted.error('利用可能な部屋の数を超えた人数')
      //   return false
      // }
      // if (this.checkValidStayRoom()) {
      //   this.$toasted.error('最大部屋数になりました。')
      //   return false
      // }
      return true
    },
    checkDayOpen() {
      return true
    },
    checkDayFewLeft() {
      return true
    },
    checkDayClose() {
      return true
    },
    checkFiveDay() {
      const countDay = moment().diff(moment(this.planRcSttDt, 'DD/MM/YYYY'), 'days')
      if (countDay > 0 && countDay <= 5) {
        return true
      }
      return false
    },
    checkDisabledDate($event) {
      const now = moment(new Date())
      return $event.isBefore(now, 'date')
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? _.cloneDeep(this.vacancyCalendar.vacancyCalendars)
          : []
      const instockDays = vacancyCalendars
        .filter((e) => e.stock > 4 || e.stock === 0)
        .map((el) => el.stayDay)
      return !$event.isBefore(now, 'date') &&
        instockDays.includes($event.format(this.dateFormat))
        ? '○'
        : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD')
      )
      return !$event.isBefore(now, 'date') ? '△' : ''
    },
    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      return !$event.isBefore(now, 'date') &&
        !inStockDays.includes($event.format(this.dateFormat))
        ? '×'
        : ''
    },
    calculateStayAmount() {
      this.selectedDaysInfo = []
      const selectedDays = _.cloneDeep(this.getSelectedDays)
      selectedDays.splice(-1)
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      let netAmount = 0

      selectedDays.forEach((day) => {
        const dayInfo = {
          stayDay: day,
          childTypePrice: {},
          roomPrice: null,
          price: null,
          adultPrice: null,
          boneSubsidy: null,
          stock: null,
          reservationDiv: null,
          childrenPriceTable: []
        }
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay))) {
            const memberPrice = vacancy.price ? vacancy.price : 0
            const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
            netAmount += this.stayAdults * memberPrice + this.stayRooms * roomPrice
            dayInfo['childTypePrice'] = {}
            if (!roomPrice) {
              dayInfo['childTypePrice']['childrenType10'] = this.getMemberChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType15'] = this.getMemberChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType20'] = this.getMemberChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType30'] = this.getMemberChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType40'] = this.getMemberChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType50'] = this.getMemberChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              dayInfo['childTypePrice']['visitorType10'] = this.getVisitorChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType15'] = this.getVisitorChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType20'] = this.getVisitorChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType30'] = this.getVisitorChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType40'] = this.getVisitorChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType50'] = this.getVisitorChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              Object.keys(this.attachChildren).forEach((key) => {
                if (this.attachChildren[key]) {
                  netAmount +=
                    this.attachChildren[key] *
                    this.getMemberChildPrice(key, vacancy.childrenPriceTable) *
                    this.stayRooms
                }
              })
            }
            dayInfo.adultPrice = vacancy.adultPrice
            dayInfo.boneSubsidy = vacancy.boneSubsidy
            dayInfo.price = vacancy.price
            dayInfo.roomPrice = vacancy.roomPrice
            dayInfo.stock = vacancy.stock
            dayInfo.reservationDiv = vacancy.reservationDiv
            dayInfo.childrenPriceTable = vacancy.childrenPriceTable
          }
        })
        this.selectedDaysInfo.push(dayInfo)
      })
      return netAmount
    },
    showPhotoGallery() {
      const query = this.$route.query
      this.$router.push({ path: '/bs-men-02-020', query })
    },
    previewPlanImage(imgInfo) {
      if (imgInfo) {
        this.previewImage = imgInfo
        this.showPreviewImg = true
      }
    },
    copyShareURL() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('コピーしました')
    },
    copyError() {
      this.$toasted.error('コピーできません')
    },
    handleOpenIntro() {
      window.open(
        'https://bs.benefit-one.co.jp/bs/pages/bo/template.faces?ih=/contents/bs_base/goriyou/'
      )
    },
    openTaxLink() {
      const { menuNo } = this.$route.query
      window.open(
        'https://bs.benefit-one.co.jp/bs/pages/bs/stay/stayTax.faces?menuNo=162372'
      )
    },
    goNext() {
      if (!this.validateOK()) {
        return
      }
      const query = this.$route.query
      const data = {
        stayDay: this.stayDay.format('YYYY/MM/DD'),
        stayDayJP: this.stayDay.format('YYYY年MM月DD日から'),
        stayNights: +this.stayNights,
        stayRooms: +this.stayRooms,
        stayAdults: +this.stayAdults,
        attachChildren: this.attachChildren,
        countTotalChildren: this.countTotalChildren,
        netAmount: this.calculateStayAmount(), // Tổng chi phí (gồm thuế),
        detailDays: this.selectedDaysInfo,
        maxStayCapacity: this.maxStayCapacity,
        minStayCapacity: this.minStayCapacity
      }
      this.$store.dispatch(SAVE_CUSTOMER_PLAN, data).then(() => {
        this.$router.push({ path: '/register-attention', query })
      })
    },
    openChildrenPolicy() {
      window.open(
        'https://bs.benefit-one.co.jp/bs/pages/bs/stay/stayTax.faces?menuNo=162372'
      )
    },
    async getGrantedBenepoStay(menuNo, planId, billingAmount) {
      await this.$repositories('plan')
        .getGrantedBenepoStay({ menuNo, planId, billingAmount })
        .then(
          (response) => {
            this.grantedBenepo = response.grantedBenepo
          },
          (error) => {
            this.$toasted.error('コンパニオン登録に失敗しました')
          }
        )
        .catch((err) => {
          console.error('getGrantedBenepoStay', err)
        })
    },
    getPlanIcons(){
      return this.planDetail?.planIcons ? _.cloneDeep(this.planDetail.planIcons) : [];
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
